import React, { useState } from 'react';
import './PaymentModal.css';

function PaymentModal({ isOpen, onClose, fatura, onDownloadBoleto }) {
  const [paymentMethod, setPaymentMethod] = useState('pix');
  const [copied, setCopied] = useState(false);

  if (!isOpen) return null;

  // Dados simulados do PIX
  const pixData = {
    qrCode: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==',
    code: '00020126580014BR.GOV.BCB.PIX0136123e4567-e12b-12d1-a456-426614174000520400005303986540599.905802BR5913UNET BANDA LARGA6008CAMPOS62070503***6304E2CA',
    key: 'unet@bandalarga.com.br'
  };

  // Função para copiar código PIX
  const copyPixCode = async () => {
    try {
      await navigator.clipboard.writeText(pixData.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback para navegadores mais antigos
      const textArea = document.createElement('textarea');
      textArea.value = pixData.code;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // Função para copiar chave PIX
  const copyPixKey = async () => {
    try {
      await navigator.clipboard.writeText(pixData.key);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      const textArea = document.createElement('textarea');
      textArea.value = pixData.key;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  // Verificar se o boleto está vencido
  const isBoletoVencido = () => {
    if (!fatura?.vencimento) return false;
    const vencimento = new Date(fatura.vencimento.split('/').reverse().join('-'));
    const hoje = new Date();
    return vencimento < hoje;
  };

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Pagamento - {fatura?.mes}</h2>
          <button className="close-button" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-content">
          {/* Resumo da Fatura */}
          <div className="fatura-resumo">
            <div className="fatura-item">
              <span className="label">Valor:</span>
              <span className="value">R$ {fatura?.valor?.toFixed(2)}</span>
            </div>
            <div className="fatura-item">
              <span className="label">Vencimento:</span>
              <span className="value">{fatura?.vencimento}</span>
            </div>
            <div className="fatura-item">
              <span className="label">Status:</span>
              <span className={`status ${isBoletoVencido() ? 'vencido' : 'a-vencer'}`}>
                {isBoletoVencido() ? 'Vencido' : 'A vencer'}
              </span>
            </div>
          </div>

          {/* Métodos de Pagamento */}
          <div className="payment-methods">
            <h3>Escolha a forma de pagamento:</h3>
            
            <div className="method-tabs">
              <button 
                className={`method-tab ${paymentMethod === 'pix' ? 'active' : ''}`}
                onClick={() => setPaymentMethod('pix')}
              >
                <i className="fas fa-qrcode"></i>
                PIX
              </button>
              <button 
                className={`method-tab ${paymentMethod === 'boleto' ? 'active' : ''}`}
                onClick={() => setPaymentMethod('boleto')}
              >
                <i className="fas fa-barcode"></i>
                Boleto
              </button>
            </div>

            {/* Conteúdo PIX */}
            {paymentMethod === 'pix' && (
              <div className="pix-content">
                <div className="pix-qr">
                  <h4>QR Code PIX</h4>
                  <div className="qr-code-container">
                    <img src={pixData.qrCode} alt="QR Code PIX" />
                  </div>
                  <p>Escaneie o QR Code com seu app bancário</p>
                </div>

                <div className="pix-code">
                  <h4>Código PIX</h4>
                  <div className="code-container">
                    <input 
                      type="text" 
                      value={pixData.code} 
                      readOnly 
                      className="pix-code-input"
                    />
                    <button 
                      className={`copy-button ${copied ? 'copied' : ''}`}
                      onClick={copyPixCode}
                    >
                      {copied ? (
                        <>
                          <i className="fas fa-check"></i>
                          Copiado!
                        </>
                      ) : (
                        <>
                          <i className="fas fa-copy"></i>
                          Copiar
                        </>
                      )}
                    </button>
                  </div>
                </div>

                <div className="pix-key">
                  <h4>Chave PIX</h4>
                  <div className="key-container">
                    <input 
                      type="text" 
                      value={pixData.key} 
                      readOnly 
                      className="pix-key-input"
                    />
                    <button 
                      className={`copy-button ${copied ? 'copied' : ''}`}
                      onClick={copyPixKey}
                    >
                      {copied ? (
                        <>
                          <i className="fas fa-check"></i>
                          Copiado!
                        </>
                      ) : (
                        <>
                          <i className="fas fa-copy"></i>
                          Copiar
                        </>
                      )}
                    </button>
                  </div>
                </div>

                <div className="pix-instructions">
                  <h4>Como pagar:</h4>
                  <ol>
                    <li>Abra o app do seu banco</li>
                    <li>Escolha a opção PIX</li>
                    <li>Escaneie o QR Code ou cole o código</li>
                    <li>Confirme o pagamento</li>
                  </ol>
                </div>
              </div>
            )}

            {/* Conteúdo Boleto */}
            {paymentMethod === 'boleto' && (
              <div className="boleto-content">
                <div className="boleto-status">
                  <div className={`status-badge ${isBoletoVencido() ? 'vencido' : 'a-vencer'}`}>
                    <i className={`fas ${isBoletoVencido() ? 'fa-exclamation-triangle' : 'fa-clock'}`}></i>
                    {isBoletoVencido() ? 'Boleto Vencido' : 'A vencer'}
                  </div>
                </div>

                <div className="boleto-actions">
                  <button className="btn-primary" onClick={() => onDownloadBoleto?.(fatura)}>
                    <i className="fas fa-download"></i>
                    Baixar Boleto
                  </button>
                  <button className="btn-secondary" onClick={() => onDownloadBoleto?.(fatura)}>
                    <i className="fas fa-print"></i>
                    Imprimir Boleto
                  </button>
                </div>

                <div className="boleto-info">
                  <h4>Informações do Boleto:</h4>
                  <ul>
                    <li><strong>Código:</strong> {fatura?.codigo}</li>
                    <li><strong>Valor:</strong> R$ {fatura?.valor?.toFixed(2)}</li>
                    <li><strong>Vencimento:</strong> {fatura?.vencimento}</li>
                    <li><strong>Status:</strong> {isBoletoVencido() ? 'Vencido' : 'A vencer'}</li>
                  </ul>
                </div>

                {isBoletoVencido() && (
                  <div className="boleto-warning">
                    <i className="fas fa-exclamation-triangle"></i>
                    <p>Este boleto está vencido. Entre em contato conosco para regularizar sua situação.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Fechar
          </button>
          <a 
            href="https://wa.me/5522999611338" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-whatsapp"
          >
            <i className="fab fa-whatsapp"></i>
            Preciso de Ajuda
          </a>
        </div>
      </div>
    </div>
  );
}

export default PaymentModal; 